var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightBlueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15039 23.9847C6.90039 23.7104 6.77539 23.3857 6.77539 23.0104C6.77539 22.6359 6.90039 22.3115 7.15039 22.0372L14.4754 14L7.12539 5.93544C6.89206 5.67943 6.77539 5.3594 6.77539 4.97537C6.77539 4.59135 6.90039 4.26218 7.15039 3.98787C7.40039 3.71357 7.69639 3.57642 8.03839 3.57642C8.37972 3.57642 8.67539 3.71357 8.92539 3.98787L17.3254 13.232C17.4254 13.3417 17.4964 13.4606 17.5384 13.5886C17.5797 13.7166 17.6004 13.8537 17.6004 14C17.6004 14.1463 17.5797 14.2835 17.5384 14.4115C17.4964 14.5395 17.4254 14.6584 17.3254 14.7681L8.90039 24.0122C8.66706 24.2682 8.37972 24.3962 8.03839 24.3962C7.69639 24.3962 7.40039 24.2591 7.15039 23.9847Z",
    fill: "#0BA9F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlueIcon);
export default __webpack_public_path__ + "static/media/arrow-right-blue-icon.e2c2683829469fa137f22e724ad4d248.svg";
export { ForwardRef as ReactComponent };